module.exports = __webpack_public_path__ + "img/category-skill-game.d4beb4ae.png";